<div>
  <mat-card appearance="outlined" class="page page-narrow">
    <mat-card-header>
      <mat-card-title>{{ 'APP_FAILURE.TITLE' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ userMessage }}</mat-card-subtitle>
    </mat-card-header>

    <a [href]="userBackLink">
      <button
        mat-raised-button
        [style.visibility]="hasBackLink() ? 'visible' : 'hidden'"
        class="wide-button"
        type="submit"
        color="accent"
      >
        Back
      </button>
    </a>
  </mat-card>
</div>
